<ng-container *ngIf="!isBreadcrumbHidden">
  <ol class="breadcrumb" aria-label="breadcrumb" aria-live="polite">
    <li *ngFor="let breadcrumb of breadcrumbs; let i = index">
      <a *ngIf="!breadcrumb.isCurrentPage" (click)="navigate($event, breadcrumb.url)"  [attr.id]="'breacrumbLink' + i">
        {{ breadcrumb.label }}
      </a>
      <span *ngIf="breadcrumb.isCurrentPage" [attr.id]="'breacrumbLabel' + i">
        {{ breadcrumb.label }}
      </span>

      <div *ngIf="i !== breadcrumbs.length-1">
        <img aria-hidden="true" src="assets/images/icons/right_arrow.svg" alt="">
      </div>
    </li>
  </ol>
</ng-container>
